import {createLazyFileRoute} from '@tanstack/react-router'

import Flights from '@/views/Account/Flights/Flights'

export const Route = createLazyFileRoute('/_account/flight-bookings/')({
  component: Flights,
})
